import React, { Suspense, useState, useEffect, useRef } from "react";
import WizardServices from "./WizardServices";
import ContactSummary from "./contactSummary";
import cachingMechanisum from "../Common/cachingMechanisum";

export default function ContactWizardRecipients(MainWizard: any) {

    const [save, setsave] = useState(false);
    const [totalRows, settotalRows] = useState(1);
    const [unfield, setunfield] = useState(false);
    const [deleteData, setdelete] = useState(false);
    const formValidation = useRef<HTMLDivElement>(null);
    const [contactInfo, initContactInfo] = useState<any>([]);
    const [RecipientsDetails, initRecipientsDetails] = useState<any>([]);
    const [RecipientFullDetails, initRecipientFullDetails] = useState<any>([]);
    const [StatementCategoryList, initStatementCategoryList] = useState<any>([]);
    const [contactPersonalDetails, initcontactPersonalDetails] = useState<any>([]);

    useEffect(() => {
        if (MainWizard.data.code) {
            WizardServices.contactInfo(MainWizard.data.code).then((res) => {
                initContactInfo(res)
            })
            WizardServices.contactsdetails(MainWizard.data.code).then((res) => {
                initRecipientsDetails(res)
                initRecipientFullDetails(res)
                settotalRows(res ? res.length : 0)
            })
        }

        const StatementCategory = "StatementCategory"

        var lookUpTypeList = cachingMechanisum.getCachingStorage("lookUpType")
        const StatementCategoryListing = lookUpTypeList?.filter((item: any) =>
            item.lookUpType.toLowerCase().includes(StatementCategory.toLowerCase())
        );
        initStatementCategoryList(StatementCategoryListing)

    }, []);

    const onPersonalInfoEdit = (e: any) => {
        console.log(e)
        initcontactPersonalDetails(e)
    }

    const clearSForm = () => {
        initcontactPersonalDetails([])
        const inputs: any = formValidation.current?.querySelectorAll('input');
        Object.values(inputs).map((values: any) => {
            var fieldName: any = document.getElementById(values.id);
            fieldName.style.border = "1px solid #47529d";

        })

    }

    const saveForm = () => {
        console.log(contactPersonalDetails);
        var validSave = handleFieldRequired(contactPersonalDetails);
        if (validSave) {

            WizardServices.RecipientSave(MainWizard.data.code, contactPersonalDetails).then((res) => {
                setsave(true);
                clearSForm();
            })
        } else {
            setunfield(true)
        }
        setTimeout(function () {
            setsave(false);
            setunfield(false);
        }, 3000);

    }

    const deleteRecipients = (e: any) => {
        console.log(e)
        //initcontactPersonalDetails([])
        WizardServices.RecipientDelete(MainWizard.data.code, e.contactId).then((res) => {
            setdelete(true);
        })
    }

    const handleFieldRequired = (object: any) => {
        const inputs: any = formValidation.current?.querySelectorAll('input');
        var valid = true;

        Object.values(inputs).map((values: any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');

            if (isRequired) {
                if (!object[values.id]) {
                    var fieldName: any = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        })
        return valid;
    }

    const handleFieldChange = (e: any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;

        console.log(Field_value)
        console.log(Field_type)
        if (Field_type === "checkbox") {
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');

        let updatedObject = { ...contactPersonalDetails };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        }

        console.log(updatedObject);
        initcontactPersonalDetails(updatedObject);
    };

    const searchRecipients = (e: any) => {
        console.log(e)

        const initialFilteredItems = RecipientFullDetails.filter((item: any) =>
            item.company.toLowerCase().includes(e.toLowerCase()) ||
            item.contactFirst.toLowerCase().includes(e.toLowerCase()) ||
            item.contactLast.toLowerCase().includes(e.toLowerCase()) ||
            item.contactEmail.toLowerCase().includes(e.toLowerCase())
        );


        if (e.length > 0) {
            initRecipientsDetails(initialFilteredItems);
            settotalRows(initialFilteredItems.length)
        }

        if (e.length === 0) {
            initRecipientsDetails(RecipientFullDetails)
            settotalRows(RecipientFullDetails.length)
        }

    }

    let [telephone2, setTelephone2] = useState(false);
    let [telephone3, setTelephone3] = useState(false);
    let [telephone4, setTelephone4] = useState(false);

    const phoneUpdate = (e: any) => {
        console.log(e)
        if (e === "telephone2") {
            telephone2 = !telephone2
            setTelephone2(telephone2);
        }
        if (e === "telephone3" && telephone2) {
            telephone3 = !telephone3
            setTelephone2(telephone3);
        }

        if (e === "telephone4" && telephone2 && telephone3) {
            telephone4 = !telephone4
            setTelephone2(telephone4);
        }
    }
    return (
        <>
            <div className="ws-12">
                <div className="w-65">

                    <div className="ws-12 ps">
                        <div className="box">
                            <div className="box-header"> <h1>Recipients</h1> </div>

                            <div className="box-content allowVscroll" style={{ marginLeft: "5%" }}>

                                <div className="ws-12" ref={formValidation}>
                                    {unfield && <div className="alert alert-danger"> There was a problem submitting your request, one or more fields are missing or incorrect.</div>}

                                    <div className="w-47">
                                        <div className="form-format ws-12">
                                            <label className="control-label">First Name*</label>

                                            <div className="label-entries">
                                                <input type="text" id="contactFirst" value={contactPersonalDetails.contactFirst ? contactPersonalDetails.contactFirst : ""}
                                                    name="contactFirst" placeholder="Enter First Name" onChange={(e) => handleFieldChange(e)} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-48">
                                        <div className="form-format ws-12">
                                            <label className="control-label">Last Name*</label>

                                            <div className="label-entries">
                                                <input type="text" id="contactLast" value={contactPersonalDetails.contactLast ? contactPersonalDetails.contactLast : ""}
                                                    name="contactLast" placeholder="Enter Last Name" onChange={(e) => handleFieldChange(e)} required />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-format ws-12">
                                        <label className="control-label">Company</label>

                                        <div className="label-entries">
                                            <input type="text" id="company" value={contactPersonalDetails.company ? contactPersonalDetails.company : ""}
                                                onChange={(e) => handleFieldChange(e)} name="company" placeholder="Enter Company" />
                                        </div>
                                    </div>

                                    <div className="form-format ws-12">
                                        <label className="control-label">Email Address *</label>

                                        <div className="label-entries">
                                            <input type="email" name="contactEmail" id="contactEmail" required onChange={(e) => handleFieldChange(e)}
                                                value={contactPersonalDetails.contactEmail ? contactPersonalDetails.contactEmail : ""} placeholder="Enter email address" />
                                            <span className="hide" >Email is required.</span>
                                            <span className="hide" >Invalid email address.</span>
                                        </div>
                                    </div>

                                    <div className="form-format ws-12">
                                        <label className="control-label">Telephone</label>
                                        <div className="label-entries">
                                            <div className="w-90">
                                                <input type="text" id="phone" value={contactPersonalDetails.telephone ? contactPersonalDetails.telephone : ""}
                                                    onChange={(e) => handleFieldChange(e)} name="telephone" placeholder="Enter telephone" />
                                            </div>
                                            <div className="w-5">
                                                <div className="verticalMediumWide hover-box text-center pull-left">
                                                    <ul className="hover-block textboxDropdownList" style={{ width: "8vw" }}>
                                                        <li className="hover-box text-left">
                                                            <input type="checkbox" checked={telephone2} onClick={() => phoneUpdate("telephone2")} />Telephone 2
                                                        </li>
                                                        <li className="hover-box text-left">
                                                            <input type="checkbox" checked={telephone3} onClick={() => phoneUpdate("telephone3")} /> Telephone 3
                                                        </li>
                                                        <li className="hover-box text-left">
                                                            <input type="checkbox" checked={telephone4} onClick={() => phoneUpdate("telephone4")} />Telephone 4
                                                        </li>
                                                    </ul>
                                                    <button className="icon-btn primary">
                                                        <i className="icon-add-solid"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-format ws-12">
                                        <div className="label-entries">
                                            {telephone2 && <input type="text" value={contactPersonalDetails.telephone2 ? contactPersonalDetails.telephone2 : ""} name="telephone2" className="mb mt" placeholder="Enter telephone 2" />}
                                            {telephone3 && <input type="text" value={contactPersonalDetails.telephone3 ? contactPersonalDetails.telephone3 : ""} name="telephone3" className="mb mt" placeholder="Enter telephone 3" />}
                                            {telephone4 && <input type="text" value={contactPersonalDetails.telephone4 ? contactPersonalDetails.telephone4 : ""} name="telephone4" className="mb mt" placeholder="Enter telephone 4" />}
                                        </div>
                                    </div>

                                    <div className="form-format ws-12">
                                        <label className="control-label">  Statement Category  </label>

                                        <div className="label-entries">
                                            <select id="statementCategory" name="statementCategory" onChange={(e) => handleFieldChange(e)}
                                                value={contactPersonalDetails.statementCategory ? contactPersonalDetails.statementCategory : ""} >
                                                <option value=""> Choose Statement Category</option>
                                                {
                                                    StatementCategoryList?.map((values: any) => {
                                                        return (
                                                            <option value={values.key} label={values.value}>{values.value}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>

                                </div>

                            </div>

                            <div className="box-footer pts">
                                <a className="icon-btn edit" onClick={() => saveForm()}>   <i className="icon-save" />  Save    </a>
                                <a className="btn-pink" onClick={() => clearSForm()}> <i className="icon-reload" />Reset   </a>
                            </div>
                        </div>
                    </div>

                    <div className="ws-12 ps">
                        <div className="box">
                            <div className="row-fluid">
                                <div className="ws-12">
                                    <div className="box-header well"> <h2> <span>{totalRows} record(s) found</span> </h2> </div>
                                    {save && <div className="alert alert-success"> Details for  has been saved successfully </div>}
                                    {deleteData && <div className="alert alert-success">Contact deleted successfully</div>}

                                    <div className="box-content">
                                        <div className="control-group">
                                            <div className="form-horizontal row-fluid mt mb" data-ng-show="contactDetailsList.length > 0">
                                                <div className="form-format ws-6">
                                                    <div className="label-entries" style={{ marginLeft: "50%" }}>
                                                        <input type="text" className="form-control input-sm" onChange={(e) => searchRecipients(e.target.value)} placeholder="Search" id="personalInfoFields" />
                                                    </div>
                                                </div>
                                            </div>
                                            {(totalRows === 0) && <div className="alert alert-info">  No records to display </div>}

                                            <div className="table-responsive mtl">
                                                {(totalRows > 0) && <table className="newTable">
                                                    <thead>
                                                        <tr>
                                                            <th>Full Name</th>
                                                            <th>Company</th>
                                                            <th>Email</th>
                                                            <th>Statement Status</th>
                                                            <th>Phone</th>
                                                            <th>Operation</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {RecipientsDetails.map((values: any) => {

                                                            return (
                                                                <tr >
                                                                    <td >{values.contactFirst} {values.contactLast} </td>
                                                                    <td >{values.company}</td>
                                                                    <td >{values.contactEmail}</td>
                                                                    <td ><a className="btn-xs pull-none text-center btn-warning">{values.statementStatusName}  </a></td>
                                                                    <td >{values.telephone}</td>
                                                                    <td >
                                                                        <a onClick={() => onPersonalInfoEdit(values)} className="icon-btn edit btn-sm"> <i className="icon-edit" /> </a>
                                                                        <a className="icon-btn delete btn-sm" onClick={() => deleteRecipients(values)}><i className="icon-close" /></a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="w-35 ps ">
                    <ContactSummary data={contactInfo} />
                </div>
            </div>

        </>
    )

}